import BackTo from './BackTo'

export default BackTo



// WEBPACK FOOTER //
// ./src/components/BackTo/index.js